import NewVM from './selector-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init(element) {
    console.log('Kadenze.CourseTypeSelector initialization function called');
    let vm = new Vue(NewVM);
    vm.bindData(JSON.parse(element.dataset.courseOptions).actions);
    vm.$mount(element);
  }
};
